var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    fillOpacity: 0.4,
    fill: "#000",
    cx: 25,
    cy: 25,
    r: 23.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 16)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.398 15.893a2.783 2.783 0 0 1-1.747-.651l-3.226-2.84a1.421 1.421 0 0 0-1.835-.089L.002 15.686v2.19A1.065 1.065 0 0 0 1.097 19h16.25c.651 0 1.303-.474 1.303-1.125v-5.74l-5.832 3.373c-.428.258-.92.391-1.42.385z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.161,
    cy: 8.851,
    r: 1.302
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.728 2.313a1.095 1.095 0 0 0-.8-.444L4.798.005a1.362 1.362 0 0 0-.888.236c-.23.2-.386.47-.444.77L3.2 3.319h14.148a2.545 2.545 0 0 1 2.487 2.455v10.444c0-.059.266-.118.384-.236.246-.193.388-.488.385-.8l1.391-12.011c.031-.31-.065-.62-.266-.858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.347 4.502H1.097c-.651 0-1.095.621-1.095 1.272v8.432l3.907-2.84a2.606 2.606 0 0 1 3.285.148l3.256 2.84a1.51 1.51 0 0 0 1.747.148l6.453-3.757v-4.97a1.361 1.361 0 0 0-1.303-1.273zm-6.186 6.835a2.486 2.486 0 1 1-.001-4.972 2.486 2.486 0 0 1 0 4.972z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6aca95b727a3c9e74737f2a4a482d003.svg";
export { ForwardRef as ReactComponent };